export class AuthenticationCommand {
    email: string;
    password: string;
}
